// import React from "react";
// import { Web3ReactProvider } from "@web3-react/core";
// import Web3 from "web3";

import wrapPageElementImpl from "./src/gatsby/browser/wrapPageElement";
import wrapRootElementImpl from "./src/gatsby/browser/wrapRootElement";

export const wrapPageElement = wrapPageElementImpl;
export const wrapRootElement = wrapRootElementImpl;
